
  import { mapGetters } from 'vuex';

  export default {
    props: {
      listKey: { type: String, default: 'list' },
      loading: { type: Boolean, default: false },
      titleKey: { type: String, default: 'institutions' }
    },
    computed: {
      ...mapGetters('search', { search: 'get' }),
      ...mapGetters('providers', { allProviders: 'getList' }),
      allProviderSlugs () {
        return this.allProviders.map(p => p.slug);
      },
      availableProviderSlugs () {
        return Object.keys(this.search).includes('available_providers') ? this.search.available_providers : this.allProviderSlugs;
      },
      /* eslint-disable camelcase */
      filteredProviderSlugs: {
        get () {
          return this.search.filtered_providers || [];
        },
        set (filtered_providers) {
          this.$store.commit('search/set', { filtered_providers });
          this.$store.dispatch('matomo/trackFilterChange', { name: `Filtering by providers: ${filtered_providers.toString()}` });
          this.$emit('saveSearch');
        }
      }
      /* eslint-enable camelcase */
    },
    methods: {
      clearAllProviders () {
        this.$store.commit('search/set', { 'filtered_providers': [] });
        this.$store.dispatch('matomo/trackFilterChange', { name: 'Filtering by providers: Cleared All' });
        this.$emit('saveSearch');
      },
      isDisabled (slug) {
        return !this.availableProviderSlugs.some(p => p === slug);
      },
      isChecked (slug) {
        return this.filteredProviderSlugs.length === 0 || this.filteredProviderSlugs.includes(slug);
      }
    }
  };
